export const ageOptions = [
  { label: '10-20', value: '10-20' },
  { label: '21-30', value: '21-30' },
  { label: '31-40', value: '31-40' },
  { label: '41-50', value: '41-50' },
  { label: '51-60', value: '51-60' },
  { label: '61+', value: '61+' },
  { label: 'All ages', value: 'all' },
];

export const goalOptions = [
  { label: 'Lose weight', value: 'lose weight' },
  { label: 'Gain muscle', value: 'gain muscle' },
  { label: 'Improve Endurance', value: 'endurance' },
  { label: 'Flexibility', value: 'flexibility' },
  { label: 'Reduce stress', value: 'reduce stress' },
  { label: 'Improve posture', value: 'improve posture' },
];

export const difficultyOptions = [
  { label: 'Beginner', value: 'beginner' },
  { label: 'Intermediate', value: 'intermediate' },
  { label: 'Expert', value: 'expert' },
  { label: 'Athlete', value: 'athlete' },
  { label: 'All levels', value: 'all levels' },
];

export const muscleGroupOptions = [
  { label: 'Abs', value: 'Abs' },
  { label: 'Arms', value: 'Arms' },
  { label: 'Back', value: 'Back' },
  { label: 'Chest', value: 'Chest' },
  { label: 'Legs', value: 'Legs' },
  { label: 'Shoulders', value: 'Shoulders' },
  { label: 'Multi-area', value: 'Multi-area' },
];

export const genderOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Any', value: 'person' },
];
